import { render, staticRenderFns } from "./SpermConcentrationInStraw.vue?vue&type=template&id=1d5cdc9e&scoped=true&"
import script from "./SpermConcentrationInStraw.vue?vue&type=script&lang=js&"
export * from "./SpermConcentrationInStraw.vue?vue&type=script&lang=js&"
import style0 from "./SpermConcentrationInStraw.vue?vue&type=style&index=0&id=1d5cdc9e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d5cdc9e",
  null
  
)

export default component.exports